/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type RenewalLinkedPolicyDto = {
    id: string;
    reference: string;
    status: RenewalLinkedPolicyDto.status;
    startDate: string;
    expiryDate: string;
};
export namespace RenewalLinkedPolicyDto {
    export enum status {
        SAVED = 'SAVED',
        ISSUED = 'ISSUED',
        VALID = 'VALID',
        EXPIRED = 'EXPIRED',
        ENDED = 'ENDED',
        CANCELLED = 'CANCELLED',
        DECLINED = 'DECLINED',
        SUPERSEDED = 'SUPERSEDED',
        REFERRAL_SUBMITTED = 'REFERRAL_SUBMITTED',
        REFERRAL_ACTION_REQUIRED = 'REFERRAL_ACTION_REQUIRED',
        QUOTED = 'QUOTED',
    }
}

